export const TEA_SPECIALTY_CODE = '-1';
